<template>
    <div>
        <h3 class="text-center mt-2">Aging Range By Vehicle Type</h3>
        <hr>
        <div ref="minMaxAging" style="min-height:500px"></div>
    </div>
    
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_kelly from "@amcharts/amcharts4/themes/kelly.js";

am4core.useTheme(am4themes_kelly);

export default {
    props : ['data'],
    data(){
        return{
            chart : null
        }
    },
    mounted(){
        this.createChart();
        this.loadData();
    },
    watch: {
        '$store.state.updateData' : function(){
            console.log(this.$store.state.filterUrl);
            this.loadData();
        }
    },
    methods : {
        loadData(){
            let length = this.chart.data.length;

            console.log(this.data);
            this.chart.addData(this.data , length)
        },
        createChart(){
            this.chart = am4core.create(this.$refs.minMaxAging, am4charts.XYChart);

            // this.chart.data = data;
            let categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis());
            categoryAxis.renderer.grid.template.location = 0;
            categoryAxis.dataFields.category = "vehicle_type";
            categoryAxis.renderer.minGridDistance = 15;
            categoryAxis.renderer.grid.template.location = 0.5;
            categoryAxis.renderer.grid.template.strokeDasharray = "1,3";
            categoryAxis.renderer.labels.template.horizontalCenter = "center";
            categoryAxis.renderer.labels.template.location = 0.5;
            categoryAxis.title.text = "Vehicle Types";
            categoryAxis.title.fontWeight = "bold";
            // categoryAxis.renderer.inside = true;


            let valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.min = 0;
            valueAxis.max = 31;
            valueAxis.renderer.ticks.template.disabled = true;
            valueAxis.renderer.axisFills.template.disabled = true;
            valueAxis.title.text = "Aging (Days)";
            valueAxis.title.fontWeight = "bold";

            let series = this.chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.categoryY = "vehicle_type";
            series.dataFields.openValueX = "min_age";
            series.dataFields.valueX = "max_age";
            series.tooltipText = "Minimum Aging : {openValueX.value} Days \n  Maximum Aging : {valueX.value} Days";
            series.sequencedInterpolation = true;
            // series.fillOpacity = 0;
            series.strokeOpacity = 1;
            series.columns.template.height = 2;
            series.tooltip.pointerOrientation = "horizontal";

            let openBullet = series.bullets.create(am4charts.CircleBullet);
            openBullet.locationX = 1;

            let closeBullet = series.bullets.create(am4charts.CircleBullet);

            closeBullet.fill = this.chart.colors.getIndex(4);
            closeBullet.stroke = closeBullet.fill;

            this.chart.cursor = new am4charts.XYCursor();

        }
    }
}
</script>